import React from 'react'

import type { TAnalysisTypeDto, TAnalysisTypeStatus } from '@homepal/api-contract'
import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'
import SectionHeader from 'components_new/molecules/SectionHeader'

const STATUSES: TAnalysisTypeStatus[] = [
  'ACTIVE',
  'INACTIVE',
  'MISSING_CONFIGURATION'
]

interface AnalysisTypesStatusOverviewProps {
  analysisTypes: TAnalysisTypeDto[]
  setStatus: (value: TAnalysisTypeStatus | null) => void
  status: TAnalysisTypeStatus | null
  sx?: SxProps
}

const AnalysisTypesStatusOverview = (
  props: AnalysisTypesStatusOverviewProps
) => {
  const { analysisTypes, setStatus, status, sx } = props
  const { t, translateEnum } = useTranslation()

  return (
    <Box sx={sx}>
      <SectionHeader
        divider={true}
        gutterBottom={true}
        title={t('global', 'status')}
      />

      <NavigationItem
        active={!status}
        item={{
          chip: {
            label: analysisTypes.length
          },
          onClick: () => setStatus(null),
          title: `${t('global', 'all')} ${t(
            'analysis_types',
            'analysis_types',
            true
          )}`
        }}
      />
      {STATUSES.map((s) => {
        const { color, pluralTitle } = translateEnum('analysis_type_status', s)

        return (
          <NavigationItem
            active={status === s}
            indent={1}
            item={{
              chip: {
                color,
                label: analysisTypes.filter(
                  (analysisType) => analysisType.status === s
                ).length
              },
              onClick: () => setStatus(s),
              title: pluralTitle
            }}
            key={s}
          />
        )
      })}
    </Box>
  )
}

export default AnalysisTypesStatusOverview
